/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ naam: NonNullable<unknown> }} Planning_Rooster_Begin_SlepenInputs */

const nl_planning_rooster_begin_slepen = /** @type {(inputs: Planning_Rooster_Begin_SlepenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Begin van ${i?.naam} slepen`)
};

/**

* @param {Planning_Rooster_Begin_SlepenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_begin_slepen = /** @type {((inputs: Planning_Rooster_Begin_SlepenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Begin_SlepenInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_begin_slepen(inputs)
});
export { planning_rooster_begin_slepen as "planning.rooster.begin_slepen" }